import {Routes} from '@angular/router';
import {kundenanlagePublicRoutes} from '@softapps/wws/kundenanlage';
import {moduleRoutes} from '@softapps/allgemein/modules';
import {connectionSettingsRoutes, settingsRoutes} from '@softapps/allgemein/utils';
import {AuthenticationGuard} from '@softline/auth';
import {loginRoutes} from '@softapps/allgemein/login';
import {passwordRoutes} from '@softapps/allgemein/password';
import {goldschmiedeRoutes} from '@softapps/feichtinger/goldschmiede';
import {wiegungRoutes} from '@softapps/feichtinger/wiegung';
import {artikelinfoRoutes} from '@softapps/handel/artikelinfo';
import {archivbelegUploadRoutes} from '@softapps/wws/archivbeleg-upload';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('@softapps/core').then((o) => o.ShellComponent),
    children: [
      //Allgemein
      ...moduleRoutes,
      ...settingsRoutes,

      // WWS
      ...artikelinfoRoutes,
      ...archivbelegUploadRoutes,

      ...goldschmiedeRoutes,
      ...wiegungRoutes,
    ],
    canActivate: [AuthenticationGuard],
  },
  {
    path: '',
    loadComponent: () =>
      import('@softapps/core').then((o) => o.PublicShellComponent),
    children: [
      ...loginRoutes,
      ...passwordRoutes,
      ...connectionSettingsRoutes,
      ...settingsRoutes,
      ...kundenanlagePublicRoutes
    ],
  },
];
